import TruncatedItem from 'components/TruncatedAccordion'
import ListAccordion from './ListAccordion'
import { formatDateAndTime } from 'utils/stringUtils'
import { isValid, parse } from 'date-fns'
import { enGB } from 'date-fns/locale'
import ObjectAccordion from './ObjectAccordion'

const isValidDate = (input: unknown): input is string => {
    const parsedDate = parse(input as string, 'P', new Date(), { locale: enGB })
    return isValid(parsedDate)
}
const shouldBeTruncated = (item: string) => item.length > 30
const isList = (value: unknown): value is Array<unknown> => Array.isArray(value)
const isObject = (value: unknown): value is Map<string, string> =>
    Object.prototype.toString.call(value) === '[object Object]'
type wrapperProps = {
    label: string
    value: string
}

export const PayloadWrapper = (props: wrapperProps): JSX.Element => {
    const { label, value } = props

    if (isList(value)) {
        return <ListAccordion key={label} label={label} splits={value} />
    }
    if (isObject(value)) {
        return <ObjectAccordion label={label} object={value} />
    }
    if (shouldBeTruncated(value)) {
        return (
            <TruncatedItem label={label}>
                <p>{String(value)}</p>
            </TruncatedItem>
        )
    }
    if (isValidDate(value)) {
        return (
            <div className={`flex justify-between my-2 ${isList(value) ? 'flex-col' : ''}`}>
                <div className="font-semibold pr-3">{String(label)}</div>
                <span>{formatDateAndTime(value)}</span>
            </div>
        )
    }
    return (
        <div className={`flex justify-between my-2 ${isList(value) ? 'flex-col' : ''}`}>
            <div className="font-semibold pr-3">{String(label)}</div>
            {String(value)}
        </div>
    )
}
